import { Link } from 'react-router-dom';
import { LegalPage } from '@/components/LegalPage';

export function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="June 18, 2026"
      intro="How Nullify Entertainment collects, uses, and protects your information when you use BingeBox."
    >
      <h2>Information we collect</h2>
      <ul>
        <li><strong>Account info:</strong> email, display name, date of birth, and a securely hashed password.</li>
        <li><strong>Usage:</strong> watch history and resume position, My List, and basic device/log data.</li>
        <li><strong>Payments:</strong> handled by Stripe — we receive billing status and receipts, never your full card number.</li>
        <li><strong>Communications:</strong> emails you opt into (verification, notifications) are sent via Resend.</li>
      </ul>

      <h2>How we use it</h2>
      <ul>
        <li>To provide the Service: sign-in, playback, resume, recommendations, and your watchlist.</li>
        <li>To process subscriptions and merch orders.</li>
        <li>To send transactional email (verification, password reset) and notifications you opt into.</li>
        <li>To enforce access rules, stream limits, age ratings, and prevent abuse.</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We don't sell your personal information. We share data only with service providers that run
        BingeBox — Cloudflare (hosting, video, database), Stripe (payments), and Resend (email) —
        under their respective terms.
      </p>

      <h2>Your choices</h2>
      <ul>
        <li>Update your profile and manage email preferences from <Link to="/account">your account</Link>.</li>
        <li>Manage cookies via <Link to="/cookies">Cookie Choices</Link>.</li>
        <li>Request access to or deletion of your data by emailing us.</li>
      </ul>

      <h2>Data retention &amp; security</h2>
      <p>
        We keep your data while your account is active. Passwords are hashed; sessions use secure,
        HTTP-only cookies; full episodes are DRM-protected. No system is perfectly secure, but we
        take reasonable measures to protect your information.
      </p>

      <h2>Children</h2>
      <p>BingeBox is not intended for children under 13, and we don't knowingly collect their data.</p>

      <h2>Contact</h2>
      <p>
        Privacy questions: <a href="mailto:support@gobingebox.com">support@gobingebox.com</a>.
      </p>

      <p className="text-xs text-ink-faint">
        This document is a general template and not legal advice. Have it reviewed by a qualified
        attorney before relying on it.
      </p>
    </LegalPage>
  );
}
